// frontend/src/modules/monitoring/deepLink.ts
//
// Shared worqly-agent:// custom-protocol handoff used by both the dashboard
// AgentSetupCard and the one-visit /agent/connect page. `navigateToDeepLink`
// is a tiny navigation seam (rather than inlining `window.location.href = …`
// at each call site) so component tests can mock it instead of stubbing
// window.location globally.

export function buildDeepLink(token: string): string {
  const server = window.location.origin;
  return `worqly-agent://setup?token=${encodeURIComponent(token)}&server=${encodeURIComponent(server)}`;
}

export function navigateToDeepLink(url: string): void {
  window.location.href = url;
}
